module.exports = __webpack_public_path__ + "img/goodsclose1.4617f201.png";